import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import { cssMap } from '@atlaskit/css';
import VideoPauseOverlayIcon from '@atlaskit/icon/core/video-pause-overlay';
import VideoPlayOverlayIcon from '@atlaskit/icon/core/video-play-overlay';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		position: 'absolute',
		insetBlockEnd: token('space.100'),
		insetInlineEnd: token('space.100'),
	},
});

/* Module-scope so identity is stable across renders without a hook. */
const PlayIcon = () => <VideoPlayOverlayIcon label="" size="small" />;
const PauseIcon = () => <VideoPauseOverlayIcon label="" size="small" />;

export type PlayPauseControlProps = {
	/**
	 * Whether the underlying renderer is currently playing.
	 */
	isPlaying: boolean;
	/**
	 * Called when the user toggles play/pause.
	 */
	onToggle: () => void;
};

/**
 * __PlayPauseControl__
 *
 * Shared play/pause `IconButton` overlay for `MotionPlayer`, absolutely
 * positioned in the bottom-right of the player container.
 */
export const PlayPauseControl = ({
	isPlaying,
	onToggle,
}: PlayPauseControlProps): React.JSX.Element => {
	return (
		<Box xcss={styles.root}>
			<IconButton
				spacing="compact"
				icon={isPlaying ? PauseIcon : PlayIcon}
				label={isPlaying ? 'Pause' : 'Play'}
				onClick={onToggle}
			/>
		</Box>
	);
};
